import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";
import { GenericPlanningConfig, FinlandAfrrInitialSocRestorationPowerEnum } from "../shared/types";
import { computeDefaultValuesGeneric } from "../shared/computeDefaultValues";
import { FieldValues } from "react-hook-form";

export const finlandAfrrPlanningConfigurations: GenericPlanningConfig[] = [
  {
    name: "planning_soc_1",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 30,
    targetSoc: 0.5,
  },
  {
    name: "planning_afrr_up",
    mode: PlanningModeEnum.fingrid_afrr,
    durationInMinutes: 45,
    engagementUpConst: "default",
    engagementDownConst: 0,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_afrr,
    initialSocRestorationPower: FinlandAfrrInitialSocRestorationPowerEnum.negative,
  },
  {
    name: "planning_soc_2",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 30,
    targetSoc: 0.5,
  },
  {
    name: "planning_afrr_down",
    mode: PlanningModeEnum.fingrid_afrr,
    durationInMinutes: 45,
    engagementUpConst: 0,
    engagementDownConst: "default",
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_afrr,
    initialSocRestorationPower: FinlandAfrrInitialSocRestorationPowerEnum.positive,
  },
];

export function computeDefaultValuesFinlandAfrr(initialData: FieldValues) {
  return computeDefaultValuesGeneric(finlandAfrrPlanningConfigurations, initialData);
}
